import { createFileRoute, redirect } from '@tanstack/react-router';

// The bare section URL lands on the first view.
export const Route = createFileRoute('/materials/')({
  beforeLoad: () => {
    throw redirect({ to: '/materials/usage' });
  },
});
